import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faGear } from '@fortawesome/pro-light-svg-icons'
import { faGear as faGearSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'

@Component({
    selector: 'fm-settings-link',
    imports: [FaIconComponent, CommonModule, RouterModule, TooltipModule],
    templateUrl: './settings-link.component.html',
    styleUrl: './settings-link.component.scss',
})
export class SettingsLinkComponent {
    public faGear = faGear
    public faGearSolid = faGearSolid
    public isHovered = false
}
